import { atom } from "recoil";

import { ICountSummary } from "../../../models";

export const notificationsCountAtom = atom<number | undefined>({
  key: "notificationsCountAtom",
  default: undefined,
});

interface INotificationsImportant {
  isLoading: boolean;
  ids: Set<number>;
  summary: ICountSummary[];
}

export const notificationsImportantAtom = atom<INotificationsImportant>({
  key: "notificationsImportantAtom",
  default: {
    isLoading: false,
    ids: new Set(),
    summary: [],
  },
});
